<template>
    <div class="coupondetail" id="coupondetail" @click.stop="goodCheckArr=[]">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="date-filter" v-if="nowType=='DAY'">
                            <el-date-picker v-model="dateStr" type="date" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
                            </el-date-picker>
                            <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
                        </div>
                        <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            placeholder="结束时间">
                            </el-date-picker>
                            <span class="quick-filter">
                                <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
                                <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
                                <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
                                <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
                                <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
                                <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
                            </span>
                            <span class="filter-tit">商品名:</span>
                                <div class="search" style="width:120px;" @click.stop="">
                                    <input type="text" class="left" placeholder="请输入商品名" v-model="goods">
                                    <i class="el-icon-search" @click="searchGoods"></i>
                                    <ul class="details_search" @click.stop="" :style="{display:(goodCheckArr[0]?'block':'none')}">
                                        <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                                            <div class="iconInner"></div>
                                        </div>
                                        <li v-for="(item,ind) in goodCheckArr" @click="selSearchGood(item,'search')" :key="ind">
                                            <div class="left name ellipsis" v-text="item.name" :title="item.name"></div>
                                        </li>
                                    </ul>
                                </div>
                            </span>
                            <span class="types typesSearch" >
                                <span type="button" @click="searchConfirm">查询</span>
                            </span>
                        </div>
                        
                        <!--  -->
                        <!-- <div class="type-change" @click="nowType=='DAY'?nowType='TIME_RANGE':nowType='DAY'">
                            <span>{{nowType=='DAY'?'按时间段查询':'按天查询'}}</span>
                        </div> -->
                    </div>
                </div>
          
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:15%">核销商品名</th>
                                <th style="width:15%">核销数量</th>
                                <!-- <th style="width:10%">会员名</th> -->
                                <!-- <th style="width:10%">规格</th> -->
                                <!-- <th style="width:15%">核销时间</th> -->
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:verifiList.length>pageSize}">
                                <!-- <table class="conTable overLengthTable"> -->
                                    <tr v-for="(item,ind) in verifiList" class="listTr">
                                        <!-- <td style="width:10%">{{item.id?ind+1+(currentPage-1)*pageSize:""}}</td> -->
                                        <td style="width:10%">{{item.productId?ind+1:""}}</td>
                                        <td style="width:15%">{{item.name}}</td>
                                        <td style="width:15%">{{item.count}}</td>
                                        <!-- <td style="width:10%">{{item.memberName}}</td> -->
                                        <!-- <td style="width:10%">{{item.spec}}</td> -->
                                        <!-- <td style="width:15%">{{item.verifiedTime | dateForGradePage}}</td> -->
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination">
                    <!-- <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination> -->
                </div>
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                nowSelGoods:undefined,
                goods:"",
                nowSelFilter:"today",
                verifiList: [], // 核销详情
                nowType:"TIME_RANGE",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
                dateStr: new Date().Format("yyyy-MM-dd"),
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
                goodSearchBtn:true,
                goodCheckArr:[],
                curGoodIdx:0
            }
        },
        watch: {
            dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM-dd"));
            let nowDate = new Date(val).Format("yyyy-MM-dd");
            this.dateStr = nowDate;
            this.getVerifiInfo(0, nowDate);
            },
            goods : function(val){
                if(val){
                    this.searchGoods(val,null)
                }else {
                    this.goodCheckArr = [];
                    this.goods = undefined;
                    this.nowSelGoods = undefined;
                    this.goodSearchBtn = true;
                }
            },
        },
        methods: {
            selSearchGood(item,boo){
                this.goods = item.name;
                this.nowSelGoods = item;
                this.searchConfirm();
                // this.goodSearchBtn = false;
                setTimeout(()=>{
                    this.goodCheckArr = [];
                },500)
            },              
            // 
             searchGoods(val,id){
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('get/coupon/product?storeId='+(id?id:this.curStoreId)).then((res)=>{
                    let filterRes = [];
                    let tempVal = String(val).trim();
                    if(res.data && Array.isArray(res.data) && res.data.length){
                        res.data.forEach(it=>{
                            if(it.name.indexOf(tempVal)!=-1){
                                filterRes.push(it);
                            }
                        })
                    }
                    if(id){
                        this.addGoodCheckArr = filterRes;
                        this.isAutoSearchBtn = false;
                        setTimeout(()=>{
                            this.isAutoSearchBtn = true;
                        },2000)
                        setTimeout(()=>{
                            let that = this;
                            $('.add_details_search li').hover( function () {
                                that.addCurGoodIdx = $(this).index()-1;
                            }, function () {
                                that.addCurGoodIdx = 0;
                            })
                        },0)
                    }else {
                        this.goodCheckArr = filterRes;
                        setTimeout(()=>{
                            let that = this;
                            $('.details_search li').hover( function () {
                                that.curGoodIdx = $(this).index()-1;
                            }, function () {
                                that.curGoodIdx = 0;
                            })
                        },0)
                    }
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            // 
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    default:
                        break;
                }
            },
            //分页方法
            handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            console.log(this.dateStr);
            if(this.nowType == "DAY"){
                this.getVerifiInfo(val - 1, this.dateStr,"DAY");
            }else{
                this.getVerifiInfo(val - 1, this.dateStr,"ARB");
            }
            },
            // 搜索
            searchConfirm: function () {
                // 
                let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("verifiCouponTimeRange",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                // 
                if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                        this.$message({
                            message: '只能查询35天内的数据',
                            customClass: 'error'
                        })
                        return;
                }
                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.canClick){
                    this.canClick = false;
                    this.getVerifiInfo(0, this.dateStr,"ARB");
                    }
                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            // 获取核销详情
            getVerifiInfo: function (page, date, type="DAY") {
                let params;
                if(type == "DAY"){
                    params = {
                        storeId:this.curStoreId,
                        time:date,
                        type,
                        page,
                        size: this.pageSize,
                    }
                }else{
                    let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    let productId = "";
                    if(this.nowSelGoods){
                        productId = this.nowSelGoods.id
                    }
                    params = {
                        storeId:this.curStoreId,
                        beginTime,
                        endTime,
                        // type,
                        // page,
                        // size: this.pageSize,
                        productId
                    }
                }
                
                this.$http({
                    url:"get/coupon/product/list",
                    method:"GET",
                    params
                }).then(res=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    let body = res.data;
                    this.verifiList = body;
                    let number = this.pageSize - this.verifiList.length;
                    this.totalElements = res.data.totalElements;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.verifiList.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        }
                    }
                }).catch((err) => {
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                });
            },
        },
        activated: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.verifiList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
            // 获取员工列表
            this.getVerifiInfo(0,this.dateStr,"ARB");
        },
        mounted: function () {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "./verifiCoupon.scss";
</style>



// WEBPACK FOOTER //
// verifiCoupon.vue?05eb0e01